/* Screedworks Custom JS — Category Dropdown */
document.addEventListener('click', function(e) {
  var opt = e.target.closest('.js-product-types.nice-select .option');
  if (!opt) return;
  var url = opt.getAttribute('data-value');
  if (url && url.startsWith('/collections')) {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = url;
  }
});
